import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'bst-frontend-vehicle-assign-modal',
  templateUrl: './vehicle-assign-modal.component.html',
  styleUrls: ['./vehicle-assign-modal.component.css'],
})
export class VehicleAssignModalComponent {
  constructor(private activeModal: NgbActiveModal) {}

  save(): void {
    this.activeModal.close({ status: 'saved' });
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }
}
